import React, { useEffect } from "react";
import { Card, Button, Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications, readAllNotification } from "./action";
import { SHOW_ALL } from "./constants";
import Notification from "./notification";
import "./style.scss";

const Notifications = ({ setCloseNotifications }) => {
  const showAll = useSelector((state) => state?.notifications?.showAll);
  const notifications = useSelector((state) => state?.notifications?.notifications);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNotifications());
  }, []);

  const handleReadAll = () => {
    const ids = [];
    notifications.forEach((i) => {
      ids.push(i.id);
    });
    readAllNotification(ids, showAll, dispatch);
  };

  return (
    <Card className="notification-container h-100 shadow">
      <Card.Header className="d-flex justify-content-between py-3">
        <p className="mb-0" style={{ cursor: "pointer" }}>
          <i className="fa-light fa-xmark mr-2 text-primary" onClick={setCloseNotifications}></i> <span className="text-lg fw-bold">What's New</span>
        </p>
        <p className="mb-0" style={{ cursor: "pointer" }} onClick={handleReadAll}>
          <i className="fa-light fa-check-double mr-2 text-primary"></i> Mark all as read
        </p>
      </Card.Header>
      <Card.Body className="overflow-auto px-0">
        <Accordion className="p-2" defaultActiveKey="0">
          {notifications?.length ? (
            <>
              {notifications?.map((notification) => {
                return <Notification key={notification.id} notification={notification} notifications={notifications} showAll />;
              })}
            </>
          ) : (
            <div className="px-3 py-2 notifyItem">
              <p className="mb-2 fw-bold">No notifications to display</p>
            </div>
          )}
        </Accordion>
      </Card.Body>
      {notifications?.length > 8 && !showAll && (
        <Card.Footer className="text-center py-2">
          <Button
            style={{ cursor: "pointer" }}
            variant="link"
            className="p-0"
            onClick={() => {
              dispatch({ type: SHOW_ALL, action: null });
              dispatch(getNotifications(true));
            }}
          >
            Show More
          </Button>
        </Card.Footer>
      )}
    </Card>
  );
};

export default Notifications;
